export default __webpack_public_path__ + "static/media/wrench.b8daaa38.png";